// libraries
import { useState } from 'react';
import styled from 'styled-components';

// components
import { ChristmasFriendQuerySection } from './query';
import { ChristmasFriendTable } from './table';

export function ChristmasFriendTableRoute(): JSX.Element {
	const [dataSource, setDataSource] = useState<any[]>([]);
	const [loading, setLoading] = useState<boolean>(true);

	return (
		<Container>
			<ChristmasFriendQuerySection setDataSource={setDataSource} setLoading={setLoading} />
			<ChristmasFriendTable dataSource={dataSource} loading={loading} />
		</Container>
	);
}

const Container = styled.main`
	display: flex;
	flex-direction: column;
	position: relative;
`;
